import writableExtendable from "@utils/storeUtils/writableExtendable";

const mediaPreview = writableExtendable({
  open: false,
  imageSrc: "",
});

export default mediaPreview;
